module.exports = __webpack_public_path__ + "assets/ic-huobi.baf1f01b.svg";